<template>


<div class="box_1 flex-row">
          <img
            class="label_1"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/header/FigmaDDSSlicePNGcdff11e08207d5782e9198c64898272b.png'"
          />
          <img
            class="image_1"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/header/FigmaDDSSlicePNG1aeb0cd94a717356e83336886e3e56ba.png'"
          />

          <router-link to='/homepage' class = 'text_1'>

            <span   :class="[this.url === '/homepage'?'select_menu':'no_select_menu']">首页</span>
          </router-link>
        
          <router-link to='/solution' class="text_2">

          <span  :class="[this.url === '/solution'?'select_menu':'no_select_menu']">解决方案</span>
          </router-link>
          <router-link to='/re_as' class="text_3">
          <span  :class="[this.url === '/re_as'?'select_menu':'no_select_menu']">康复助手</span>
          </router-link>


          <el-dropdown class="text_4">
            <span :class="[this.url === '/workstation'|| this.url === '/e26' ||this.url === '/evaluation'?'select_menu':'no_select_menu']">
              产品介绍<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <router-link to='/workstation' > <el-dropdown-item :class="[this.url === '/workstation' ?'select_menu':'no_select_menu']">通用医疗运动处方工作站</el-dropdown-item></router-link>
              <router-link to='/e26' >
              <el-dropdown-item :class="[this.url === '/e26'?'select_menu':'no_select_menu']">PF-E26智能运动处方一体机</el-dropdown-item></router-link>
             <router-link to='/evaluation'>
             <el-dropdown-item :class="[this.url === '/evaluation'?'select_menu':'no_select_menu']">健康体适能测评仪</el-dropdown-item>
            </router-link>
            </el-dropdown-menu>
          </el-dropdown>
          <router-link to='/quotation' class="text_5">
          <span  :class="[this.url === '/quotation'?'select_menu':'no_select_menu']">功能及报价</span>
          </router-link>
          <router-link to='/about' class="text_6">
          <span  :class="[this.url === '/about'?'select_menu':'no_select_menu']">关于我们</span>
          </router-link>
          <div @click="toTools" style="cursor: pointer;" class="group_3 flex-row">
            <span class="text_7" >登录</span>
           
          </div>
        </div>
  
</template>


  
  <script>
    export default {
      data() {
        return {
          activeIndex: '1',
          activeIndex2: '1',
          url: '/lanhu_shouyegaiban'
        };
      },
      async mounted(){
        this.url = this.$route.path
          console.log(this.$route.path)
      },
      methods: {
        handleSelect(key, keyPath) {
          console.log(key, keyPath);
        },
        toTools(){
          window.location.href=  'https://yd-tool.ktangtang.com/login'
        }

      }
    }
  </script>
  <style scoped lang="css" src="./assets/index.rem.css" />